import React, { useState, useEffect } from 'react';
import { Button, Dialog, Box, makeStyles, DialogTitle, DialogContent, Grid } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { CORP_BLUE } from 'config/config';

import { Preview } from '@mui/icons-material';
import RenderFile from 'customComponents/RenderFile';


const addStyle = makeStyles(theme => ({
  previewStyle: {
    color: 'black',
    cursor: 'pointer',
    padding: 2,
    '&:hover': {
      color: CORP_BLUE,
    },
  },
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    backgroundColor: CORP_BLUE,
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: 'white',
    },
  },
  num: {
    display: 'block',
    width: '100%',
  },
}));

const defaultReclamo = {
  n_reclamo: '',
};

const ModalProrroga = props => {
  const { openDialog = false, close, reclamo = defaultReclamo, /* reload, setReload */ } = props;
  const classes = addStyle();
  const [num, setNum] = useState('');
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [getInfoShown, setGetInfoShown] = useState(0);
  const [url, setUrl] = useState('');
  const [showOficioProrroga, setShowOficioProrroga] = useState(false);

  const startPreview = () => {
    setShowOficioProrroga(true);
  };

  useEffect(() => {
    if (reclamo) {
      setNum(reclamo.n_reclamo ? reclamo.n_reclamo : 'nulo');
      setUrl('')
    }
  }, [reclamo]);

  const onCloseDialog = event => {
    close();
    setGetInfoShown(0);
    setLoading(false);
  };

  const getView = () => {
    if (getInfoShown === 0) {
      return infoView();
    }

    if (getInfoShown === 1) {
      return resultView();
    }
  };

  const infoView = () => {
    return (
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
        Mediante la siguiente acción se realizará una prórroga de {reclamo !== null ? reclamo.dias_prorroga : null} días
        hábiles al plazo establecido inicialmente. ¿Está seguro que desea realizar la solicitud de prorroga?
      </Box>
    );
  };

  const resultView = () => {
    return (
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
        <Grid container>
          <Grid item xs={10}>
            Prórroga realizada, el oficio fue generado.
          </Grid>
          <Grid item xs={2}>
            <Preview
              onClick={() => {
                startPreview();
              }}
              className={classes.previewStyle}
              style={{ fontSize: 34, padding: 2 }}
            />
          </Grid>
        </Grid>
      </Box>
    );
  };

  const loadingView = () => {
    return (
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
        Realizando solicitud de prórroga.
      </Box>
    );
  };

  const onSubmitClick = () => {
    /*     setLoading(true);
    let data = {
      n_reclamo: reclamo.n_reclamo,
      run_rec: reclamo.run_rec,
    };
    asignarProrroga(data)
      .then(res => {
        if (res.status === 200) {
          setUrl(res.data);
          setGetInfoShown(1);
          setReload(!reload);
        }
        if (res.status === 202) {
          toast.error(res.data.message);
        }
      })
      .catch(err => {
        toast.error('Ocurrió un error al solicitar la prórroga.');
        console.error(err);
      })
      .finally(e => {
        setLoading(false);
      }); */
  };

  const closeOficio = () => {
    setShowOficioProrroga(false);
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <DialogTitle className={classes.dialogTitleRoot}>
        <label className={classes.num}>Solicitud de prórroga Reclamo N° {num} </label>
      </DialogTitle>
      <DialogContent dividers>
        {/* aca van las vistas */}
        {loading ? loadingView() : getView()}
        {getInfoShown === 0 ? (
          <Box display="flex" justifyContent="flex-end" mb={4}>
            <Button onClick={onCloseDialog} disabled={loading}>
              &nbsp;Cancelar&nbsp;
            </Button>
            <Box ml={2}>
              <Button variant="outlined" color="primary" onClick={onSubmitClick} disabled={loading}>
                {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Aceptar'}
              </Button>
            </Box>
          </Box>
        ) : (
          <Box display="flex" justifyContent="flex-end" mb={4}>
            <Button onClick={onCloseDialog} disabled={loading} variant="contained" color="primary">
              &nbsp;Cerrar&nbsp;
            </Button>
          </Box>
        )}
      </DialogContent>
      {showOficioProrroga ? <RenderFile openDialog={showOficioProrroga} url={url} close={closeOficio} /> : null}
    </Dialog>
  );
};

export default ModalProrroga;
